import { useEffect, useMemo, useState } from 'react';
import { api } from '../api/client';
import { DecompositionWaterfall } from '../components/charts/DashboardCharts';
import { useFilters } from '../context/FilterContext';
import type { ScenarioResult } from '../types';
import { AREA_ROUTES } from '../types';

export function DecompositionPage() {
  const [data, setData] = useState<ScenarioResult | null>(null);
  const { filters } = useFilters();

  useEffect(() => {
    api.decomposition().then(setData).catch(console.error);
  }, []);

  const linkages = useMemo(() => {
    if (!data) return [];
    let rows = [...data.linkage_contributions];
    if (filters.policyAreaId) {
      const areaName = AREA_ROUTES[filters.policyAreaId];
      if (areaName) rows = rows.filter((c) => c.policy_area === areaName);
    }
    if (filters.variableId) {
      rows = rows.filter((c) => c.variable_id === filters.variableId);
    }
    return rows.sort((a, b) => Math.abs(b.contribution_pp) - Math.abs(a.contribution_pp));
  }, [data, filters]);

  if (!data) return <div className="loading">Loading decomposition…</div>;

  return (
    <div>
      <h1 className="page-title">Growth Decomposition</h1>
      <p className="page-subtitle">
        Baseline → policy areas → interactions → simulated GDP under the selected scenario ({data.scenario_name}).
      </p>
      <div className="card">
        <DecompositionWaterfall selected={data} />
      </div>
      <div className="card">
        <h3>Linkage Detail {filters.policyAreaId || filters.variableId ? '(filtered)' : ''}</h3>
        <table className="data-table">
          <thead>
            <tr><th>Variable</th><th>Area</th><th>Method</th><th>Contribution (pp)</th></tr>
          </thead>
          <tbody>
            {linkages.map((c) => (
              <tr key={c.link_id} className={filters.variableId === c.variable_id ? 'row-highlight' : undefined}>
                <td>{c.variable_name}</td>
                <td>{c.policy_area}</td>
                <td>{c.method}</td>
                <td>{c.contribution_pp.toFixed(4)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
